import { baseCrudFactory } from "~/stores/base.crud.store.ts"

export const useUserStore = baseCrudFactory({
    title: "user",
    endpoint: "admin/users",
    primaryKey: "id",
})
